import { render, staticRenderFns } from "./AssignmentBin.vue?vue&type=template&id=359c9096&"
import script from "./AssignmentBin.vue?vue&type=script&lang=js&"
export * from "./AssignmentBin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359c9096')) {
      api.createRecord('359c9096', component.options)
    } else {
      api.reload('359c9096', component.options)
    }
    module.hot.accept("./AssignmentBin.vue?vue&type=template&id=359c9096&", function () {
      api.rerender('359c9096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/assignmentBin/AssignmentBin.vue"
export default component.exports